import fc from './fetchInterceptor';
import { getAuthHeaders, loggedIn } from './authorizator.js';
import { getToken } from 'businessLogic/authorizator.js';

export function queueESEvents(
  eventType,
  eventValue,
  uniqByKey,
  additionalValue,
  cb,
  trimLogValue = true,
  logLevel = 'error'
) {
  if (loggedIn() && (logLevel === 'error' || (logLevel === 'info' && ifInfoLoggingTurnoff()))) {
    try {
      // Only log events when user is logged in and logging is turned on
      let eventValueString = '';
      try {
        if (typeof eventValue === 'string') {
          eventValueString = eventValue;
        } else {
          eventValueString = JSON.stringify(eventValue);
        }

        if (trimLogValue) eventValueString = eventValueString.substring(0, 120);
      } catch (err) {
        console.error(err);
      }
      let logEvent = {
        userAgent: getUserAgent(),
        localPersonId: getLoggedInUserId(),
        clientTimestamp: getTimestamp(),
        eventSource: 'VCM',
        eventType: eventType,
        eventValue: eventValueString,
        eventCount: 1,
        uniqByKey: uniqByKey,
        ...additionalValue,
      };
      // If localPersonId is empty, do not log it
      if (logEvent.localPersonId === '' || typeof logEvent.localPersonId != 'number') {
        return;
      }
      let queueEventsArray = [];
      try {
        queueEventsArray = window.localStorage.getItem('queuedEvents');
      } catch (err) {
        window.localStorage.removeItem('queuedEvents');
      }

      if (!queueEventsArray) {
        queueEventsArray = [];
      } else {
        try {
          queueEventsArray = JSON.parse(queueEventsArray);
        } catch (err) {
          console.error(err);
          queueEventsArray = [];
        }
      }

      if (!!queueEventsArray && Array.isArray(queueEventsArray)) {
        if (uniqByKey) {
          let foundIndex = -1;
          let uniqKeySortArr = uniqByKey.split('&');
          if (uniqKeySortArr.length === 1) {
            let uniqKeyArr = uniqKeySortArr[0].split('.');
            foundIndex = queueEventsArray.findIndex((event) => {
              let gotValueInEvent = uniqKeyArr.reduce((a, v) => a[v], event);
              let gotValueInLogEvent = uniqKeyArr.reduce((a, v) => a[v], logEvent);
              return gotValueInEvent === gotValueInLogEvent && event.localPersonId === logEvent.localPersonId;
            });
          } else if (uniqKeySortArr.length === 2) {
            let uniqKeyArr1 = uniqKeySortArr[0].split('.');
            let uniqKeyArr2 = uniqKeySortArr[1].split('.');
            foundIndex = queueEventsArray.findIndex((event) => {
              let gotValueInEvent1 = uniqKeyArr1.reduce((a, v) => a[v], event);
              let gotValueInLogEvent1 = uniqKeyArr1.reduce((a, v) => a[v], logEvent);
              let gotValueInEvent2 = uniqKeyArr2.reduce((a, v) => a[v], event);
              let gotValueInLogEvent2 = uniqKeyArr2.reduce((a, v) => a[v], logEvent);
              return (
                gotValueInEvent1 === gotValueInLogEvent1 &&
                gotValueInEvent2 === gotValueInLogEvent2 &&
                event.localPersonId === logEvent.localPersonId
              );
            });
          }
          if (foundIndex > -1) {
            // If already exists in the array, increase the count
            let currentCount = queueEventsArray[foundIndex].eventCount;
            queueEventsArray[foundIndex].eventCount = currentCount + 1;
            // Use last similar event timestamp
            queueEventsArray[foundIndex].clientTimestamp =
              logEvent.clientTimestamp > queueEventsArray[foundIndex].clientTimestamp
                ? logEvent.clientTimestamp
                : queueEventsArray[foundIndex].clientTimestamp;
            window.localStorage.setItem('queuedEvents', JSON.stringify(queueEventsArray));
          } else {
            // If not exists, then push
            queueEventsArray.push(logEvent);
            window.localStorage.setItem('queuedEvents', JSON.stringify(queueEventsArray));
          }
        } else {
          queueEventsArray.push(logEvent);
          window.localStorage.setItem('queuedEvents', JSON.stringify(queueEventsArray));
        }
      }
      if (cb) cb();
      if (window.timer === undefined) {
        window.timer = setTimeout(sendESEventsBunch, window.APP.CONFIGURATION.ES_LOG_EVENT_TIMEOUT || 30000);
      }
    } catch (error) {
      console.error('Queue ES event error: ', error);
    }
  }
}

export function sendESEventsBunch(resentIfFail, xmlHttp) {
  // Don't do anything if portalsetting doesn't allow to send
  if (!ifLoggingTurnoff()) {
    window.localStorage.setItem('queuedEvents', '[]');
    window.localStorage.setItem('unsentEvents', '[]');
    // Force to clear timer
    clearTimeout(window.timer);
    window.timer = undefined;
    return;
  }
  try {
    // Need to handle async when fetch starts and ends
    // between fetch there might be more events to log
    let vcmEvents = [];
    let unsentVcmEvents = [];
    try {
      vcmEvents = window.localStorage.getItem('queuedEvents');
    } catch (err) {
      window.localStorage.removeItem('queuedEvents');
    }

    try {
      unsentVcmEvents = window.localStorage.getItem('unsentEvents');
    } catch (err) {
      window.localStorage.removeItem('queuedEvents');
    }
    window.localStorage.setItem('queuedEvents', '[]');
    window.localStorage.setItem('unsentEvents', '[]');

    // Force to clear timer
    clearTimeout(window.timer);
    window.timer = undefined;
    try {
      vcmEvents = JSON.parse(vcmEvents);
    } catch (err) {
      vcmEvents = [];
    }
    try {
      // parse resent events
      unsentVcmEvents = JSON.parse(unsentVcmEvents);
    } catch (err) {
      unsentVcmEvents = [];
    }

    if (vcmEvents && vcmEvents.length === 0) {
      if (unsentVcmEvents && unsentVcmEvents.length === 0) {
        // There's no new events / unsent events
        return;
      } else {
        // No new events, just need to send unsent events
        vcmEvents = unsentVcmEvents;
      }
    } else if (unsentVcmEvents && unsentVcmEvents.length > 0) {
      // If there are any unsent events, need to combine them in the same array
      // And remove duplicate and increase count by uniqBy rule
      let array1 = [...vcmEvents];
      let array2 = [...unsentVcmEvents];
      let newVcmEvents = array1.concat(array2);
      let reducedMap = newVcmEvents.reduce((acc, currentValue) => {
        if (currentValue.uniqByKey) {
          let index = -1;
          let uniqKeySortArr = currentValue.uniqByKey.split('&');
          if (uniqKeySortArr.length === 1) {
            let uniqKeyArr = uniqKeySortArr[0].split('.');
            index = acc.findIndex((event) => {
              let gotValueInEvent = uniqKeyArr.reduce((a, v) => a[v], event);
              let gotValueInLogEvent = uniqKeyArr.reduce((a, v) => a[v], currentValue);
              return gotValueInEvent === gotValueInLogEvent && event.localPersonId === currentValue.localPersonId;
            });
          } else if (uniqKeySortArr.length === 2) {
            let uniqKeyArr1 = uniqKeySortArr[0].split('.');
            let uniqKeyArr2 = uniqKeySortArr[1].split('.');
            index = acc.findIndex((event) => {
              let gotValueInEvent1 = uniqKeyArr1.reduce((a, v) => a[v], event);
              let gotValueInLogEvent1 = uniqKeyArr1.reduce((a, v) => a[v], currentValue);
              let gotValueInEvent2 = uniqKeyArr2.reduce((a, v) => a[v], event);
              let gotValueInLogEvent2 = uniqKeyArr2.reduce((a, v) => a[v], currentValue);
              return (
                gotValueInEvent1 === gotValueInLogEvent1 &&
                gotValueInEvent2 === gotValueInLogEvent2 &&
                event.localPersonId === currentValue.localPersonId
              );
            });
          }
          if (index > -1) {
            let prevcount = acc[index].eventCount;
            let accCount = currentValue.eventCount;
            acc[index].eventCount = prevcount + accCount;
            // Use last event timestamp
            acc[index].clientTimestamp =
              currentValue.clientTimestamp > acc[index].clientTimestamp
                ? currentValue.clientTimestamp
                : acc[index].clientTimestamp;
            return acc;
          } else {
            return [...acc, currentValue];
          }
        } else {
          return [...acc, currentValue];
        }
      }, []);
      vcmEvents = reducedMap;
    }
    if (!!vcmEvents) {
      if (xmlHttp) {
        sendToESXMLHttp(vcmEvents, resentIfFail);
      } else {
        sendToES(vcmEvents, resentIfFail);
      }
    }
  } catch (error) {
    console.error('Send events to ES error: ', error);
  }
}

function sendToESXMLHttp(events, resentIfFail, cb) {
  console.log('[Log to ES]Logging events to ES. ', events);
  var api = window.APP.CONFIGURATION.VCCAPI + 'clientevents';

  var xmlhttp = new XMLHttpRequest();
  xmlhttp.onreadystatechange = function () {
    if (xmlhttp.readyState == 4) {
      if (xmlhttp.status == 200) {
        if (cb) cb(true);
      } else {
        if (cb) cb(false);
        if (resentIfFail === false) {
          return;
        }
      }
    }
  };
  xmlhttp.open('POST', api, true);
  xmlhttp.setRequestHeader('Content-type', 'application/json');
  xmlhttp.setRequestHeader('Authorization', 'Bearer ' + getToken());
  xmlhttp.send(JSON.stringify(events));
}

export function sendToES(events, resentIfFail, cb) {
  if (!!events) {
    console.log('[Log to ES]Logging events to ES. ', events);
    var api = window.APP.CONFIGURATION.VCCAPI + 'clientevents';
    fc.post(
      api,
      {
        body: JSON.stringify(events),
      },
      {
        cb: cb,
        ignoreDisplayErrors: true,
        errorCallback: () => {
          // Not show any red message
        },
      }
    )
      .then((result) => {
        if (cb) cb(true);
      })
      .catch((err) => {
        if (cb) cb(false);
        if (resentIfFail === false) {
          return;
        }
        console.error('Log events to Error', err);
        // If error is 400 || 500  (user doesn't have token), dump the events (do nothing)
        // else need to resend it next time
        if (
          err &&
          (err.status === 400 ||
            err.status === 401 ||
            err.status === 500 ||
            err === 400 ||
            err === 401 ||
            err === 500 ||
            err === '400' ||
            err === '401' ||
            err === '500')
        ) {
          return;
        }
        let unsentVcmEvents = [];
        try {
          unsentVcmEvents = window.localStorage.getItem('unsentEvents');
        } catch (err) {
          window.localStorage.removeItem('queuedEvents');
        }

        try {
          // parse resent events
          unsentVcmEvents = JSON.parse(unsentVcmEvents);
        } catch (err) {
          unsentVcmEvents = [];
        }
        let unsentVcmEvents1 = [...unsentVcmEvents];
        let unsentVcmEvents2 = [...events];
        let newUnsentVcmEvents = unsentVcmEvents1.concat(unsentVcmEvents2);
        window.localStorage.setItem('unsentEvents', JSON.stringify(newUnsentVcmEvents));
      });
  }
}

export function ifLoggingTurnoff() {
  // During page refresh it could be null / undefined, then should not send event
  if (window.getState().usersReducer.userProfile.enableVcmLoggingToES === true) {
    return true;
  }
  return false;
}

export function ifInfoLoggingTurnoff() {
  // During page refresh it could be null / undefined, then should not send event
  if (window.getState().usersReducer.userProfile.sendVcmInfoLogsToEs === true) {
    return true;
  }
  return false;
}

export function getLoggedInUserId() {
  return window.getState().usersReducer.userProfile.id || '';
}

export function getUserAgent() {
  return navigator.userAgent;
}

export function getTimestamp() {
  var timestamp = new Date();
  return timestamp.toJSON();
}

export const ESEventTypes = {
  RedMessageShown: 'Red Error message Shown',
  PubNubHeartbeatReceived: 'Pubnub heartbeat received?',
  PubNubHeartbeatHardLimitReach: 'Pubnub heartbeat hard limit reached',
  PubNubHeartbeatSoftLimitReach: 'Pubnub heartbeat soft limit reached',
  PubNubDownReloading: 'Pubnub down and reloading',
  RequestHeartbeatAPIError: 'Request personal pubnub heartbeat API error',
  CallQualityProfiles: 'Error getting the call quality profiles', // Call quality profile is not in use in VCM
  GetGAIdError: 'Error getting the google Analytics Id',
  ResubscribeMissingChannels: 'reSubscribeMissingPubnubChannels(##skipReconnect##)',
  UnSubscribeAdditionalChannels: 'unSubscribeAdditionalPubnubChannels',
  PubnubStatusError: 'Pubnub Status Error',
  RemoveUnsubscribeChannels: 'Remove the unsubscribe channels',
  PubnubStatusChange: 'Pubnub Status Change',
  UnknownPubnubStatus: 'Unknown Pubnub Status',
  FetchAPIError: 'Fetch API Error',
  InsufficientSubscribeLevel: 'Insufficient subscription level ##url##',
  HidingHotjarException: 'Hiding Hotjar due to exception',
  InvalidHotjarId: 'Invalid Hot Jar id ?',
  GetHotJarIdError: 'Error in getting the Hot Jar Id api',
  FailToPlayAudio: 'Failed to play audio file',
  NotificationAPIUnavailableToShowAlert: 'HTML5 Web Notification API available in this browser to show alert ?',
  NewCallerNotificationShown: 'New caller notification message shown',
  NotificationNotShown: 'Web Notification not shown',
  NotificationAPIUnavailableToRequestPermit:
    'HTML5 Web Notification API is available in this browser to permit alert ?',
  UserBlockNotification: 'User blocked Web Notifications',
  UnknownStatusForNotificationPermit: 'Unkown status for Web Notifications user permission',
  PubnubWarningMessageMount: 'PubnubWarningMessage componentDidMount',
  PubnubWarningRefreshBtnClick: 'PubnubWarningMessage onRefreshNowClicked',
  PubnubWarningMessageUnmount: 'PubnubWarningMessage componentWillUnmount',
  UpgradePlanPageShown: 'Upgrade plan page shown',
  NotFoundPageShown: 'Page not found shown',
  PubNubUnhealthyAutoReload: 'Pubnub unhealthy auto page reload',
  AbortControllerError: 'AbortController error',
  GetPubnubUpdates: 'Get pubnub update',
  RdirectingTo: 'Rdirecting to',
  APICall: 'API Call',
  GCSettingsAPIError: 'Error getting the GC Settings WA/Org',
  GCSettingsUpdateAPIError: 'Error updating the GC Settings WA/Org',
  GCSettingsWAUpdate: 'GC Settings Waiting Area level update',
  GCSettingsOrgUpdate: 'GC Settings Orgnizational level update',
  CallingWADetails: 'Function getWaitingAreasDetails called',
};
